<template>
  <div>
    <el-aside :width="isCollapse ? '63px' : '260px'">
      <div class="menu-top">
        <div class="menu-flex"> 
          <img class="img1" v-if="$store.state.imageUrl && $store.state.imageUrl != 'null'" :src="url+$store.state.imageUrl" alt="">
          <img class="img1" v-else src="@/assets/images/logo.png" alt="">
          <p class="hospital-name" v-if="!isCollapse">{{$store.state.orgName}}</p> 
          <i class="fold-icon el-icon-s-fold" v-if="!isCollapse" @click="cloneHandel"></i>
          <div class="foldMenu" v-else>
            <i class="fold-icon el-icon-s-unfold" @click="cloneHandel"></i>
          </div>
        </div>
      </div>
      <div class="menu-view">
        <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
          <el-menu router :default-active="$route.path === '/Chaining/case-6'?fromPath:$route.path"
            class="el-menu-vertical-demo" background-color="#29313D" text-color="rgba(254,254,254,.65)"
            active-text-color="#fff" :collapse-transition="false" :collapse="isCollapse">
            <template v-for="item in $store.state.menuData">
              <NavMenu v-if="item.children.length" :data="item" :key="item.id" :interactionNumber="interactionNumber" />
              <el-menu-item v-else :index="item.component" :key="item.id">
                <i :class="item.icon" class="icon-menu"></i>
                <span slot="title">{{ item.name }}</span>
              </el-menu-item>
            </template>
          </el-menu>
        </el-scrollbar>
      </div>
      <div class="menu-bottom">
        <el-dropdown @command="editpwd">
          <div class="el-dropdown-link">
            <!-- <el-badge v-if="messageNum" :value="messageNum" class="menu-badge">
              <img src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" alt="">
            </el-badge> -->
            <img src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" alt="">
            {{username}}<i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">修改密码</el-dropdown-item>
            <el-dropdown-item command="2">退出系统</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-aside>
  </div>
</template>

<script>
// import { api_routerjurisdiction } from "@/api/acc.js";
import local from "@/utils/local.js";
import NavMenu from "./NavMenu";
import { getUnreviewedCount } from "@/views/termPage/interaction/api/index.js";
import { PublicNewMsg } from "@/store/socketsMessage";
export default {
  data() {
    return {
      url: process.env.VUE_APP_OSS_URL, 
      fromPath: "", 
      username: "",
      messageNum: 0,
      speech: null,
      interactionNumber: 0 // 患友互动角标
    };
  },
  components: {
    NavMenu
  },
  computed: {
    isCollapse() {
      return this.$store.state.isCollapse;
    }
  },
  watch: {
    $route: "getPath",
    "$websocket.state.messageNumber"(val) {
      if (val > 99) {
        this.messageNum = "99+";
      } else {
        this.messageNum = val;
      }
    }
  },
  created() {
    this.$store.dispatch("getMenuList");
    let fromPathName = localStorage.getItem("fromName");
    if (fromPathName === "医生链") {
      this.fromPath = "/Chaining/case-1";
    }
    if (fromPathName === "患者链") {
      this.fromPath = "/Chaining/case-2";
    }
    if (fromPathName === "模板链") {
      this.fromPath = "/Chaining/case-3";
    }
  },
  mounted() {
    this.username = local.get("userInfoName");
    if (this.$websocket.state.messageNumber > 99) {
      this.messageNum = "99+";
    } else {
      this.messageNum = this.$websocket.state.messageNumber;
    }
    this.getNumber();
  },
  methods: {
    PublicNewMsg: PublicNewMsg,
    //获取未读消息数
    getNumber() {
      getUnreviewedCount().then(res => {
        if (res.data < 0) {
          res.data = 0;
        }
        this.interactionNumber = res.data;
      });
    },
    cloneHandel() {
      this.$store.commit("updataIsCollapse", !this.$store.state.isCollapse);
    },
    editpwd(command) {
      if (command == "1") {
        this.$store.commit("setPassWordDialogChange", command);
      } else {
        local.clear();
        this.$router.push({
          path: "/login"
        });
        // 注销websocket
        this.sockets.unsubscribe("currentMenu");
      }
    },
    getPath(to, from) {
      if (from.path) {
        this.fromPath = from.path;
      }
      this.getNumber();
    },
    getCurrentMenu(path) {
      switch (path) {
        case "/case":
          return "intoCase";
          break;
        case "/case-2":
          return "smallRoom";
          break;
        case "/case-3":
          return "task";
          break;
        case "/case-4":
          return "feedback";
          break;
        case "/case-5":
          return "patientFiles";
          break;
        case "/case-6":
          return "clockIn";
          break;
        case "/case-8":
          return "doctorNurse";
          break;
        case "/patientmanage":
          return "patient";
          break;
      }
    }
  },
  sockets: {
    newMsg(data) {
      console.log("全局页面newMsg事件");
      this.PublicNewMsg(data, this);
    },
    //更新消息列表
    replied(data) {
      console.log("全局页面更新replied事件！");
      this.PublicNewMsg(data, this, true);
    }
  }
};
</script>

<style lang="less" scoped>
.menu-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hospital-name {
  color: #fff;
  width: 156px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.menu-badge {
  /deep/.el-badge__content.is-fixed {
    top: 20px;
    right: 30px;
  }
  /deep/.el-badge__content {
    width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 50%;
    padding: 0;
    text-align: center;
    border: none;
    background: #f14352;
  }
}

.el-aside {
  background: #29313d;
  height: 100%;
  .menu-top {
    background: #1f2a3b;
    div {
      padding: 14px 15px;
      img {
        display: inline-block;
        vertical-align: middle;
      }
      .img1 {
        width: 32px;
        height: 32px;
        object-fit: cover;
      }
      .img2 {
        width: 72px;
        height: 13px;
        margin-left: 10px;
      }
      .fold-icon {
        font-size: 20px;
        color: #fff;
        float: right;
        padding-top: 6px;
        cursor: pointer;
      }
      .foldMenu {
        position: fixed;
        width: 26px;
        height: 26px;
        top: 11px;
        left: 63px;
        background: rgba(0, 0, 0, 0.65);
        border-radius: 0px 3px 3px 0px;
        z-index: 999;
        padding: 0;
        i {
          float: none;
          padding: 2px 0 0 2px;
        }
      }
    }
  }
  .menu-bottom {
    height: 75px;
    white-space: nowrap;
    background: #1f2a3b;
    padding-left: 14px;
    cursor: pointer;
    .el-dropdown-link {
      line-height: 75px;
      color: #fff;
      img {
        width: 32px;
        height: 32px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
      }
    }
  }
  .menu-view {
    height: calc(100% - 137px);
  }
  .el-menu {
    border-right: 0;
    .icon-menu {
      margin-right: 20px;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .el-scrollbar__view {
    .is-active {
      background-color: #1a7bfc !important;
      color: #fff !important;
    }
  }
}
</style>